import { changelog } from "@/mocks/home";

export default function Changelog() {
  return (
    <section id="changelog" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-widest text-primary-700">UPDATES</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            版本更新记录
          </h2>
          <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
            想确认自己用的是不是最新版？对照下面的版本号即可。每次更新通常集中在流畅度、缓存与阅读体验上。
          </p>
        </div>

        <ol className="mt-10 relative border-l border-background-300 ml-2 md:ml-3 space-y-8">
          {changelog.map((item) => (
            <li key={item.version} className="pl-6 md:pl-8 relative">
              <span className="absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full bg-accent-500 ring-4 ring-background-100"></span>
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-heading text-lg font-bold text-foreground-950">{item.version}</span>
                <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label">
                  {item.scope}
                </span>
                <span className="text-xs text-foreground-500">{item.date}</span>
              </div>
              <ul className="mt-3 space-y-2">
                {item.notes.map((note) => (
                  <li key={note} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5"></i>
                    {note}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}